import { Typography } from '@mui/material';
import { styled, keyframes } from '@mui/system';

const scrollRightToLeft = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

const scrollLeftToRight = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export const ScrollingTextContainer = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  backgroundColor: 'transparent',
  padding: theme.spacing(2),
  position: 'relative',
}));

export const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden',
  width: '100%',
});

export const ScrollText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: "left" | "right" }>(({ theme, direction }) => ({
  display: 'inline-block',
  textTransform: 'uppercase',
  color: 'transparent',
  WebkitTextStroke: `2px ${theme.palette.primary.main}`,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  minWidth: '50%',
  animation:`${direction === 'left' ? scrollRightToLeft : scrollLeftToRight} 12s linear infinite`,
  paddingRight: '50%',
  fontSize: '3rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '4rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '6rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '8rem',
    paddingRight: '65%',
    animationDuration: '20s',
  },
  '&:hover': {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
}));